import { getDefaultAuthRedirectUrl } from '@/shared/auth/utils/getDefaultAuthRedirectUrl';
import { combinePathAndQuery } from '@/utils/combinePathAndQuery';
import { getSafeRedirectUrl } from '@/utils/urlValidation';

interface Params {
  /** 회원가입 디테일(memberInfo) 완료 여부. false면 가입 마무리 화면으로. */
  registrationStatus: boolean | undefined;
  /** UserInfo.type(소문자) 또는 raw memberType(대문자) 모두 허용. */
  userType: string | null | undefined;
  /** 보호 페이지 복귀용 callbackUrl(없으면 빈 문자열). */
  callbackUrl: string;
  /** 가입 미완료 시 /sign-up/type 에 이어붙일 현재 쿼리(utm 등). */
  query: Record<string, string | string[] | undefined>;
}

/**
 * 로그인/계정전환 성공 후 이동할 목적지를 결정한다(일반 로그인·계정전환 분기 공용 단일 소스).
 *
 * - 미가입(registrationStatus=false): 가입 마무리(/sign-up/type)로 강제.
 * - 가입 완료: 안전한 callbackUrl 이 있으면 그곳, 없거나 외부면 role 기본 목적지로 폴백.
 *
 * 순수 함수 — 네비게이션(router/window)은 호출 측이 수행한다.
 */
export function resolvePostLoginDestination({
  registrationStatus,
  userType,
  callbackUrl,
  query,
}: Params): string {
  if (!registrationStatus) {
    return combinePathAndQuery('/sign-up/type', query);
  }

  return getSafeRedirectUrl(callbackUrl, getDefaultAuthRedirectUrl(userType));
}
